import { CollectionStatusEnum } from "../types/Api";
export var collectionInitialValues = {
    type: undefined,
    publisher: undefined,
    issn: "",
    mainName: "",
    qualifier: "",
    status: CollectionStatusEnum.UNKNOWN,
    endYear: undefined,
    medium: undefined,
    otherLanguageNames: [],
};
